import React from "react";

/**
 * Render a translated string and insert mobile-only `<br>` tags at every
 * `\n` character. On `md+` viewports the breaks are hidden so the natural
 * wrap continues to apply. Used to honour the poetic CJK line-break tempo
 * on phones without breaking the desktop editorial flow.
 */
export const renderWithMobileBreaks = (str) => {
  const parts = String(str ?? "").split("\n");
  if (parts.length === 1) return str;
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {i > 0 && (
        <>
          {/* desktop gets a space, mobile gets a line break */}
          <span className="hidden md:inline"> </span>
          <br className="md:hidden" />
        </>
      )}
      {part}
    </React.Fragment>
  ));
};

/**
 * Same as `renderWithMobileBreaks` but the `<br>` is ALWAYS visible — used
 * for the EN typography where the user requested a permanent forced break
 * (Hero subtitle, Section 01 subtitle) rather than a mobile-only cue.
 */
export const renderWithAllBreaks = (str) => {
  const parts = String(str ?? "").split("\n");
  if (parts.length === 1) return str;
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {part}
    </React.Fragment>
  ));
};

/**
 * Dual-marker helper: `\n` = mobile-only break, `\r` = desktop-only break.
 * Used when the mobile break-point and desktop break-point differ
 * (e.g. the FAQ philosophy question — mobile splits after the comma,
 * desktop splits after "寫信" for perfect 9+9 character symmetry).
 */
export const renderWithDualBreaks = (str) => {
  const s = String(str ?? "");
  const desktopSegs = s.split("\r");
  return desktopSegs.map((deskSeg, di) => {
    const mobileSegs = deskSeg.split("\n");
    return (
      <React.Fragment key={`d${di}`}>
        {di > 0 && <br className="hidden md:block" />}
        {mobileSegs.map((m, mi) => (
          <React.Fragment key={`m${mi}`}>
            {mi > 0 && <br className="md:hidden" />}
            {m}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  });
};
